import './comp.css';
import {Row, Col, Typography} from 'antd';


function Portfolio(){

    return (
        
        <div >
            <Row className="text" justify="center" >
                <Col span={16} align="center">
                    <Typography>UX Writing & Content Design Portfolio</Typography>
                    <br/>
                    <Typography>
                        <a href="https://www.figma.com/deck/GgkALTIl8NgTtDFZH27X4C/UX-Writing-Portfolio?node-id=2-221&t=AerlZqWV87iZRnqk-1">View slide deck in Figma</a> or <a href="https://drive.google.com/file/d/1bCXvwwB4PaWn0sobunmK3UbZGkgMq3-7/view?usp=sharing">Access PDF via Google Drive </a>
                        </Typography>
                    <br/>
                    <iframe
                        src="https://embed.figma.com/slides/GgkALTIl8NgTtDFZH27X4C/UX-Writing-Portfolio?node-id=2-221&embed-host=share" 
                        allowfullscreen
                        width="100%"
                        height="800"
                    />
                    <br/>
                    <br/>
                    <Typography>Some details in these projects have been modified or redacted to protect confidential company information. Projects shown here were completed in collaboration with designers, engineers, and product managers. Some interface screens have been recreated for demonstration purposes.</Typography>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </div>
    )
}

export default Portfolio; 